import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ShoppingCartDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { BasicError } from 'projects/shared/lib/error/basic-error';
import { ICartService, ICartServiceToken } from 'shared/services/data/cart/cart-service.interface';

@Component({
  template: '',
  standalone: false
})
export class ProductAddToCartTemplateDialogBaseComponent implements OnInit {
  private readonly cartDataService: ICartService;

  @Output() modalYes: EventEmitter<ShoppingCartDto> = new EventEmitter<ShoppingCartDto>();
  @Output() modalCancel: EventEmitter<void> = new EventEmitter();

  public shoppingCartList: ShoppingCartDto[] | undefined;
  public shoppingCartTemplate: ShoppingCartDto | undefined;
  public shoppingCartTemplateNewName: string | undefined;

  public constructor() {
    this.cartDataService = inject(ICartServiceToken);
  }

  public ngOnInit(): void {
    this.templateListLoadAsync();
  }

  public close() {
    this.modalCancel.emit();
  }

  public yes() {
    this.modalYes.emit(this.shoppingCartTemplate);
  }

  public newCartShow() {
    this.shoppingCartTemplateNewName = "";
  }

  public newCartCreate(templateName: string | undefined) {
    if (templateName == undefined) {
      return;
    }

    if (templateName.length <= 0) {
      return;
    }

    this.cartDataService.cartTemplateAdd(templateName).subscribe(
      async (result) => {
        if (result.cartNumber != undefined) {
          await this.templateListLoadAsync();

          let newTemplate = this.shoppingCartList?.find(t => t.cartNumber === result.cartNumber);

          if (newTemplate) {
            this.shoppingCartTemplate = newTemplate;
          }

          this.shoppingCartTemplateNewName = undefined;
        }
      }
    );
  }

  private async templateListLoadAsync() {
    await firstValueFrom(this.cartDataService.cartTemplateListChangedGet()).then((result) => {
      this.shoppingCartList = result;
      if (result != undefined && result.length > 0) {
        this.shoppingCartList = result.sort((a, b) => {
          if (a.createDate != undefined && b.createDate != undefined) {
            return b.createDate.getTime() - a.createDate.getTime();
          }
          return 0;
        });
        this.shoppingCartTemplate = result?.[0];
      }
    }).catch((error) => {
      ServiceLocator.injector.get(LoggerService).warn(error, this.constructor.name);
      let errorMessage = $localize`:@@ProductAddToCartListDialogTemplateListLoadErrorMessage:Could not load shopping lists`;
      throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
    });
  }
}
